/**
 * Game rules, shared by every game type: the public page of a game's rounds
 * and what each one allows (games.swtorbit.com/game/ID/CODE, live once the
 * admin publishes it), and the /game Discord post made from it.
 *
 * A snapshot is public and made fresh from the game: it never holds player,
 * Discord, socket or admin ids, or positions, and a part the admin keeps
 * secret is sent as `{ secret: true }` with nothing else.
 *
 * Prefix: "GameRules" / "Rules"
 */
/** Longest game description the rules page shows. */
export const GAME_PUBLIC_DESCRIPTION_MAX = 2000;
